import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { AddIntermediaryBankDetailsPayload } from 'types/beneficiaries'
import { createBankAddressSchema } from 'utils/yupSchemas/addressSchemas'
import { createNameSchema } from 'utils/yupSchemas/createNameSchema'

export const addIntermediaryBankDetailsSchema = (t: TFunction<'translation', undefined>) => {
  const bicMinLength = 8
  const bicMaxLength = 11
  const intermediaryBankName = createNameSchema(
    t('manageBeneficiaries.intermediarysBankName'),
    t,
    null,
    250
  )
  const intermediaryBicLabel = t('bic')
  const intermediaryBic = yup
    .string()
    .label(intermediaryBicLabel)
    .min(
      bicMinLength,
      t('fieldMinLength', {
        field: intermediaryBicLabel,
        min: bicMinLength,
      })
    )
    .matches(
      /^[0-9a-zA-Z]+$/,
      t('fieldAlphanumeric', {
        field: intermediaryBicLabel,
      })
    )
    .max(
      bicMaxLength,
      t('fieldMaxLength', {
        field: intermediaryBicLabel,
        max: bicMaxLength,
      })
    )
  const intermediaryBankRoutingNumber = yup
    .string()
    .label(t('abaRoutingNumber'))
    ?.notRequired()
    .test({
      test(value, ctx) {
        if (value && value?.length !== 9) {
          return ctx.createError({
            message: t?.('fieldExactDigitLength', {
              field: t('abaRoutingNumber'),
              amount: 9,
              interpolation: { escapeValue: false },
            }),
          })
        }

        return true
      },
    })
  const intermediaryBankAddressLine1 = createBankAddressSchema(t('bankAddressLine1'), t, true)
  const intermediaryBankAddressLine2 = createBankAddressSchema(t('bankAddressLine2'), t, true)
  const intermediaryBankCity = createBankAddressSchema(t('city'), t, true)
  const intermediaryBankPostCode = createBankAddressSchema(t('postCode'), t, true)
  const intermediaryBankRegion = createBankAddressSchema(t('region'), t, true)
  const intermediaryBankCountry = yup.string().trim().label(t('country')).required()

  const formFields = {
    intermediaryBankName,
    intermediaryBic,
    intermediaryBankRoutingNumber,
    intermediaryBankAddressLine1,
    intermediaryBankAddressLine2,
    intermediaryBankCity,
    intermediaryBankPostCode,
    intermediaryBankRegion,
    intermediaryBankCountry,
  }

  return yup.object<Partial<Record<keyof AddIntermediaryBankDetailsPayload, yup.AnySchema>>>(
    formFields
  )
}
